<template>
  <div>
    <v-navigation-drawer
      width="420"
      temporary
      absolute
      fixed
      right
      dark
      style="position:fixed; top: 80px;"
      class="px-2 navbar"
      hide-overlay
      v-model="options_c"
    >
      <v-layout row pt-3 pl-2 pb-2>
        <v-flex>
          <v-subheader
            class="font-weight-regular display-1 white--text pl-0 ml-2"
          >
            Options
            <v-spacer></v-spacer>
            <a
              @click="options_c = false"
              class="font-weight-regular display-1 white--text"
            >
              X</a
            >
            <!-- <v-btn small flat @click="clearFilters()">X</v-btn> -->
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-divider class="mx-3 pb-0 mb-0 white"></v-divider>

      <v-layout row pt-0 my-3>
        <v-flex>
          <v-subheader class="white--text">
            <!-- <v-spacer></v-spacer> -->
            <v-btn @click="exportExcel" outline
              >Download artworks with tags in Excel</v-btn
            >
          </v-subheader>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>

    <!-- // delete dialog -->
    <v-dialog v-model="dialog" max-width="590">
      <v-card>
        <v-card-title class="headline"
          >Are your sure to delete "<strong>{{ tagToDelete.name }}</strong
          >" tag?</v-card-title
        >

        <v-card-text>
          This tag and all it's assignemts to artwroks will be deleted.
        </v-card-text>

        <v-card-actions class="pa-3">
          <div class="flex-grow-1"></div>

          <v-btn color="green darken-1" text @click="dialog = false">
            Cancel
          </v-btn>

          <v-btn color="red darken-1" text @click="deleteTag(tagToDelete.id)">
            Delete Tag
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- // edit dialog -->
    <v-dialog v-model="edit_dialog" max-width="700px">
      <!-- <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
        </template> -->
      <v-card class="pb-2">
        <v-card-title>
          <h1 class=" mx-4 mt-3">#{{ editedItem.name }}</h1>
          <v-flex xs12 class="mx-4 mt-1">
            Tag created by: {{ editedItem.created_by > 0 ? getUser(editedItem.created_by) : 'System' }}  [ID: {{ editedItem.id }}]
          </v-flex>
        </v-card-title>
        <v-card-text class="my-0 py-0">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.name"
                  label="Tag Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.alternatives"
                  label="Alternatives"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.subcategory"
                  label="Subcateogry"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-model="editedItem.section"
                  :items="['concept', 'cataloguing', 'private', 'custom']"
                  label="Section"
                  single-line
                ></v-select>
              </v-flex>
              <!-- <v-flex xs12>
                <v-select
                v-model="editedItem.tag_category_id"
                :items="all_categories"
                item-text="name"
                item-value="id"
                label="Tag Category"
                single-line
                ></v-select>
              </!v-flex-->
            </v-layout>
          </v-container>
          <!-- :search="search[editedItem.id]" -->
          <!-- v-model="selected_related" -->
          <!-- :headers="artworkHeaders" -->
          <h2 class="mx-4 mt-3 mb-0 py-0">Artworks</h2>
          <v-data-table
            :items="filteredArtworks(editedItem.id)"
            item-key="id"
            item-value="id"
            item-text="title"
            v-model="selected_related"
            no-data-text="No Artworks with this tag."
            no-results-text="No Artworks match the criteria."
            class="elevation-0 mx-4 px-0 py-0 my-0"
            hide-headers
          >
            <template slot="items" slot-scope="props">
              <td class="subheading py-0 px-0 mx-0">
                {{ props.item.accession_number }},
                {{ props.item.title }},
                ({{ props.item.production_date_new }})

              </td>
            </template>
          </v-data-table>
          
        </v-card-text>

        <v-card-actions class="mx-3 pb-4 pt-0 mb-0">
          <v-spacer></v-spacer>
          <v-btn color="" outline flat @click="close">Cancel</v-btn>
          <v-btn color="black" dark flat @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card class="elevation-0 mx-3 py-5">
      <!-- // Add Tag Form -->
      <!-- <add-new /-->
      <!-- // SEARCH field -->
      <v-card-title>
        <v-layout row my-3 ml-2 mr-3>
          <!-- <span>
            <v-menu
              offset-y
              :close-on-content-click="true"
              class="text-xs-right mx-4 my-0 py-0 align-center"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  icon
                  color="black"
                  dark
                  v-on="on"
                  class="text-xs-right mx-0 mt-2 my-0 py-0"
                >
                  <v-icon white small>mdi-tag-multiple</v-icon>
                </v-btn>
              </template>
              <v-list value="3">
                <v-list-tile
                  v-for="(item, index) in computed_categories"
                  :key="index.id"
                  @click="toggleCategory(item)"
                >
                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </span>
          <span class="text-xs-left mt-2 pt-1 title">
            {{ selectedCategory }}
          </span> -->

          <v-flex class="mt-2 ml-0 pl-0">
            <v-btn-toggle v-model="tag_filter" mandatory>
              <v-btn
                small
                flat
                key="all"
                class="px-2"
                input-value="all"
                value="all"
              >
                <span> All </span>
              </v-btn>
              <v-btn
                small
                flat
                key="concept"
                class="px-2"
                input-value="concept"
                value="concept"
              >
                <span> concept </span>
              </v-btn>
              <v-btn
                small
                flat
                key="cataloguing"
                class="px-2"
                input-value="cataloguing"
                value="cataloguing"
              >
                <span> cataloguing </span>
              </v-btn>
              <v-btn
                small
                flat
                key="private"
                class="px-2"
                input-value="private"
                value="private"
              >
                <span> private </span>
              </v-btn>
              <v-btn
                small
                flat
                key="custom"
                class="px-2"
                input-value="custom"
                value="custom"
              >
                <span> custom </span>
              </v-btn>
            </v-btn-toggle>
          </v-flex>

          <!-- // addnew dialog -->
          <add-new-form />
          <v-spacer></v-spacer>
        </v-layout>

        <v-spacer></v-spacer>
        <v-text-field
          v-if="this.$store.state.showSearch"
          append-icon="search"
          label="Search Tags "
          single-line
          hide-details
          clearable
          v-model="search"
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :pagination.sync="pagination"
        :headers="headers"
        :items="filteredTags"
        :search="search"
        item-key="id"
        must-sort
        expand
        :loading="$store.state.loading_tags"
        rows-per-page-text="Tags per page"
        no-results-text="No Tags match the criteria."
        class="elevation-0 mx-4 px-0"
      >
        <template slot="items" slot-scope="props">
          <tr
            :class="{
              'py-2': true,
              'px-0': true,
              black: props.expanded,
              'white--text': props.expanded
            }"
          >
            <!-- <td style="width:20px;">
              <v-checkbox color="black" hide-details v-model="props.selected" @change="save_currently_selected(props.selected,props.item)" ></v-checkbox>
            </td> -->
            <td class="pl-0 " @click="editItem(props.item)">
              <a class="subheading font-weight-bold" @click="editItem(props.item)" >#{{ props.item.name }}</a><br>
              {{ props.item.subcategory }} 
            </td>
            <!-- <td class=" subheading">
              {{ props.item.alternatives }}
            </td> -->
            <!-- <td class="subheading">
            </td> -->
            <!-- <td class="subheading">
               {{ props.item.section }} 
            </td> -->
            <td class="subheading" :color="props.item.color">
               {{ tag_category(props.item.tag_category_id) }}
            </td>
            
            <!-- SELECTION FUNCTIONS  -->
            <td class="px-4 pb-2">
              <v-tooltip bottom class="mr-3">
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="black"
                    icon
                    small
                    @click="loadSelection(props.item.id)"
                    v-on="on"
                  >
                    <v-icon small color="white">apps</v-icon>
                  </v-btn>
                </template>
                <span
                  >Load Selection ({{ currentSelection.length }}) </span
                >
              </v-tooltip>

              <v-tooltip bottom class="mr-3">
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="black"
                    icon
                    small
                    @click="addToSelection(props.item.id)"
                    v-on="on"
                  >
                    <v-icon small color="white">add</v-icon>
                  </v-btn>
                </template>
                <span
                  >Add Artworks with this Tag to current Selection</span
                >
              </v-tooltip>
            </td>

            <!-- <td-- class="text-xs-left subheading">
              {{ filteredArtworks(props.item.id).length }}
              <a
                href="#"
                @click="props.expanded = !props.expanded"
                class="right"
                v-if="filteredArtworks(props.item.id).length > 0"
              >
                <v-icon
                  v-if="!props.expanded"
                  :class="{ 'white--text': props.expanded }"
                  >expand_more</v-icon
                >
                <v-icon
                  v-if="props.expanded"
                  :class="{ 'white--text': props.expanded }"
                  >expand_less</v-icon
                >
              </a>
            </td--> 
            <!-- <td class="text-xs-center"> <span class="ml-3 body-1" >{{ format_date(props.item.created_at) }}</span> </td> -->
            <!-- <td class="text-xs-center"> {{ get_user(props.item.created_by) }} </td> -->
            <!-- <td>
            </td> -->
            <td class="text-xs-right">
              <!-- <a @click="" class="mr-5 grey--text">Add to Artwork</a>
              <a @click="" class="mr-5 grey--text">Add to Artist</a> -->
              <!-- <a @click="showConfDeleteTag(props.item.id)" class="grey--text">Delete</a> -->

              <v-tooltip bottom v-if="anySelected">
                <template v-slot:activator="{ on }">
                  <!-- <v-icon color="primary" dark v-on="on">home</v-icon> -->
                  <v-btn
                    v-on="on"
                    icon
                    @click="add_tag_to_current_selection(props.item.id)"
                    alt="Add this Tag to artworks in Current Selection"
                  >
                    <v-icon color="green lighten-1">mdi-tag-plus</v-icon>
                  </v-btn>
                </template>
                <span
                  >Add this Tag <br />to artworks <br />in Current
                  Selection</span
                >
              </v-tooltip>

              <v-tooltip bottom v-if="anySelected">
                <template v-slot:activator="{ on }">
                  <v-icon color="primary" dark v-on="on">home</v-icon>
                  <v-btn
                    v-on="on"
                    icon
                    @click="
                      add_artworks_to_selection(filteredArtworks(props.item.id))
                    "
                    alt="Add all artworks with this tag to selection"
                  >
                    <v-icon color="green lighten-1">mdi-tag-multiple</v-icon>
                  </v-btn>
                </template>
                <span
                  >Add artworks with this Tag <br />to Current Selection</span
                >
              </v-tooltip>

              <!-- <v-btn icon @click="show_artworks_with_tag" alt="Show artworks with tag">
                <v-icon color="grey lighten-1">image</v-icon>
              </v-btn>  -->

              <!-- <artwork-list-buttons :artworks="props.item.artworks"></artwork-list-buttons> -->

              <v-btn
                small
                icon
                @click="showConfDeleteTag(props.item.id)"
                v-if="c_user.delete_rights"
              >
                <v-icon small color="red lighten-1">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>

        <!-- <template v-slot:expand="props">
          <v-card-title>
            <v-text-field
              v-model="search[props.item.id]"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="artworkHeaders"
            :items="filteredArtworks(props.item.id)"
            :search="search[props.item.id]"
            class="elevation-0 mx-4"
            hide-actions
            must-sort
            disable-pagination
          ></v-data-table>

        <v-flex
          style="background-color:#292929; color: #eee;"
          class="px-3 py-1 my-0 elevation-0 xs12"
        >
          <h3 class="font-weight-bold subtitle xs12 flex">&nbsp; &nbsp;</h3>
          </v-flex> 
        </!template-->

        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <index-load-state
            :loading="$store.state.loading_tags"
            :error="$store.state.load_errors.tags"
            empty-text="No Tags Found."
          ></index-load-state>
        </template>
      </v-data-table>

      <!-- <v-data-table disable-pagination must-sort class="elevation-0 mx-4" hide-actions
        :headers="headers"
        :items="tags"
        :search="search"
        v-model="selected"
        item-key="id"
        >
        <template slot="items" slot-scope="props">
          <td style="width:20px;">
            <v-checkbox color="black" hide-details v-model="props.selected" @change="save_currently_selected(props.selected,props.item)" ></v-checkbox>
          </td>
          <td style="text-align:left; width:15 0px;" class="subheading"> {{props.item.name}} </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table> -->
    </v-card>
  </div>
</template>

<script>
import axios from '@/utils/apiClient'
import XLSX from 'xlsx'
// import ArtworkListButtons from '../layout/ArtworkListButtons.vue';
import AddNewForm from '../tags/AddNewForm.vue';
import { serverBus } from '../../main';
import IndexLoadState from '@/components/general/IndexLoadState.vue'
export default {
  components: { AddNewForm, IndexLoadState },
  // components: { ArtworkListButtons },
  data() {
    return {
      selectedCategory: 'all',
      tag_filter: 'all',
      // selectedCategory: '',
      filtered: [],
      snack: false,
      snackColor: '',
      snackText: '',
      pagination: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'name'
      },
      pagination_related: {
        descending: true,
        // rowsPerPage: 10,
        sortBy: 'title'
      },
      ta: [],
      showConf: false,
      dialog: false,
      edit_dialog: false,
      editedIndex: -1,
      editedItem: {},
      tag_title: '',
      tag_category_name: '',
      tag_category_id: 0,
      tagToDelete: {},
      save_tag_form_display: false,
      save_tag_category_form_display: false,
      selected_tags: [],
      selected: [],
      search: '',
      headers: [
        // { align: 'center', sortable: false },
        { text: 'Tag name', value: 'name', align: 'left' },
        // { text: 'Alternatives', value: 'alternatives', align: 'left' },
        { text: 'Subcategory', value: 'subcategory', align: 'left' },
        // { text: 'Section', value: 'section', align: 'left' },
        { text: 'Category', value: 'tag_category_id', align: 'left' },
        // { text: 'Artworks', align: 'left', sortable: false },
        // { text: '' },
        { text: '' }
      ],
      artworkHeaders: [
        { text: 'Artwork Title', sortable: true, value: 'title' },
        { text: 'Accession Number', value: 'accession_number', align: 'right' }
      ],
      pagination_related: {
        descending: true,
        // rowsPerPage: 10,
        sortBy: 'title'
      },
      search_related: '',
      selected_related: [],
      headers_related: [
        { text: 'Artwork Title', sortable: true, value: 'title' },
        { text: 'Accession Number', value: 'accession_number', align: 'right' }
        // { text: '', sortable:false, align: 'right' },
        // { text: 'Artist', value: 'artist_name', align: 'right' }
        // { text: 'End', value: 'duration_end', align: 'center', }
        // { text: 'Tags', value: 'tags', sortable: false }
      ]
    }
  },
  created: function() {
    this.$store.dispatch('loadTags')
    // this.$store.dispatch('loadTagCategories')
    this.toggleCategory(this.computed_categories[0])
    // this.tag_categories = this.$store.state.tag_categories
  },
  mounted: function() {
    this.toggleCategory(this.computed_categories[0])
    // this.tag_categories = this.$store.state.tag_categories
  },
  computed: {
    filteredTags() { 
      // console.log(this.tag_filter)
      if (this.selectedCategory != this.computed_categories[0]) {
        // console.log('1')
        return (
          this.$store.state.tags
            // .slice(0, 2)
            .filter(a => {
              switch (this.tag_filter) {
                case 'concept':
                  return a.section == 'concept'
                  break
                case 'cataloguing':
                  return a.section == 'cataloguing'
                  // return a.category != '' && !a.section
                  break
                case 'private':
                  return a.section == 'private'
                  // return a.category != '' && !a.section
                  break
                case 'custom':
                  return a.section == 'custom'
                  // return a.category != '' && !a.section
                  break
                default:
                  return true
                  break
              }
            })
        )
      } else {
        // console.log('2')
        return this.$store.state.tags
      }
      // return this.$store.state.tags.filter
    },
    all_categories() {
      return this.$store.state.tag_categories
    },
    computed_categories() {
      var a = Object.assign([], this.all_categories)
      a.unshift({ id: 'all', name: 'All' })
      return a
    },
    currentSelection() {
      return this.$store.state.currentSelection
    },
    anySelected() {
      return this.$store.state.currentSelection.length > 0
    },
    tags() {
      return this.$store.state.tags
    },
    options_c: {
      get() {
        return this.$store.state.options
      },
      set(value) {
        this.$store.dispatch('saveOptions', value)
      }
    }
  },
  methods: {
    // returns all artworks which have tag with this id assigned
    filteredArtworks(id) {
      // console.log('id', id)
      return this.$store.state.artworks.filter(a => {
        // console.log('a.id', a.id)
        // console.log('a.tags', a.tags)
        if (a.tags && a.tags.length > 0) {
          var hasTag = Array.isArray(a.tags) && a.tags.some(t => t.id === id)
        } else {
          var hasTag = false
        }
        // console.log('hasTag', hasTag)
        return hasTag
      })
    },
    toggleCategory(o) {
      this.selectedCategory = o.name
      if (o != this.computed_categories[0]) {
        this.filtered = this.tags.filter(
          a => a.tag_category_id == o.id && a.category == this.tag_filter
        )
      } else {
        this.filtered = this.tags
      }
    },
    editItem(item) {
      // console.log(item)
      this.editedIndex = this.tags.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.edit_dialog = true
    },
    // deleteItem (item) {
    //   const index = this.tags.indexOf(item)
    //   confirm('Are you sure you want to delete this Tag?') && this.desserts.splice(index, 1)
    // },
    close() {
      this.edit_dialog = false
      setTimeout(() => {
        this.editedItem = {}
        // Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    // save () {
    //   if (this.editedIndex > -1) {
    //     Object.assign(this.desserts[this.editedIndex], this.editedItem)
    //   } else {
    //     this.desserts.push(this.editedItem)
    //   }
    //   this.close()
    // },
    tag_category(id) {
      if (id > 0) {
        var tg = this.$store.state.tag_categories.find(tc => tc.id === id)
        if (tg) {
          return tg.name
        } else {
          return '–'
        }
      } else {
        return ' - '
      }
    },
    save() {
      let url = `${this.$globals.apiserver}/tags/${this.editedItem.id}.json`
      axios
        .put(url, { tag: this.editedItem, user_id: this.$store.state.user_id })
        .then(response => {
          this.$store.dispatch('loadTags')
          serverBus.$emit('showSnackbar', 'Tag saved.', 'green')
          this.result = response.data
        })
        .catch(error => {
          serverBus.$emit('showSnackbar', 'Tag was NOT saved. Error occured.', 'red')
          // console.log(error)
        })
      this.close()
      this.$store.dispatch('loadTags')
    },
    cancel() {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    open() {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    remove_tag_from_artwork(tag_id, artwork_id) {
      var list = Object.assign(
        {},
        this.$store.state.lists.find(list => list.id == tag_id)
      )
      list.artworks = list.artworks.filter(a => a != artwork_id)
      this.$store.dispatch('removeTagFromArtwork', {
        l: tag_id,
        a: artwork_id
      })
    },
    exportExcel() {
      // var col = ['id','name'].concat(this.columns)
      var settings = {
        // skipHeader: true,
        origin: 'A2'
      }
      let transformedData = this.$store.state.artworks.map(textRow => {
        var tm = textRow.tags.map(a => a.id)
        var ts = this.tags.filter(t => {
          return tm.includes(t.id)
        })
        // console.log(ts)
        return {
          ID: textRow.id,
          Title:
            textRow.title +
            ', ' +
            (textRow.production_date_new ? textRow.production_date_new : ''),
          Artist: textRow.full_name,
          Tags: ts.map(t => t.name).join(', ')
        }
      })
      var sheet = XLSX.utils.json_to_sheet(transformedData, settings)
      // var sheet = XLSX.utils.json_to_sheet(this.data)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      // XLSX.utils.book_append_sheet(wb, animalWS, 'animals')
      // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, sheet, this.name)

      // export Excel file
      function appendLeadingZeroes(n) {
        if (n <= 9) {
          return '0' + n
        }
        return n
      }
      let current_datetime = new Date()
      let formatted_date =
        current_datetime.getFullYear() +
        '-' +
        appendLeadingZeroes(current_datetime.getMonth() + 1) +
        '-' +
        appendLeadingZeroes(current_datetime.getDate()) +
        '-' +
        appendLeadingZeroes(current_datetime.getHours()) +
        '_' +
        appendLeadingZeroes(current_datetime.getMinutes()) +
        '_' +
        appendLeadingZeroes(current_datetime.getSeconds())
      // console.log(formatted_date)
      XLSX.writeFile(wb, 'ArtworksWithTags-' + formatted_date + '.xlsx') // name of the file is 'book.xlsx'
    },
    show_create_tag_form() {
      this.save_tag_form_display = true
      return null
    },
    showConfDeleteTag(id) {
      this.dialog = true
      this.tagToDelete = this.tags.find(t => t.id == id)
    },
    create_tag() {
      // var o = Object.assign({ name: this.tag_title})
      // if (this.$refs.form.validate()) {
      // console.log(this.artwork)
      let url = `${this.$globals.apiserver}/tags.json`
      // console.log(url)
      axios
        .post(url, {
          tag: {
            name: this.tag_title,
            tag_category_id: this.tag_category_id,
            created_by: this.$store.state.user_id
          }
        })
        .then(response => {
          // this.result = response.data
          // this.artist = response.data
          this.$store.dispatch('loadTags')
          // this.$store.dispatch('createTag',response.data)
          this.save_tag_form_display = false
          this.tag_title = ''
          // this.artwork = response.data
          // this.artist = response.data.artist
          // this.e1 = 3
          // console.log(this.artwork)
          // this.$router.push({
          //   name: 'EditTag',
          //   // path: `/artists/edit/${this.artist.id}`,
          //   params: { id: this.tag.id, artist: this.artist }
          // });
        })
        .catch(error => {
          // console.log(error)
        })
      // }
      // },
      // this.$store.dispatch('createTag', o)
      // console.log(o)
    },
    // create_tag_category() {
    //   let url = `${this.$globals.apiserver}/tag_categories.json`
    //   axios
    //     .post(url, {
    //       tag_category: {
    //         name: this.tag_category_name,
    //         created_by: this.$store.state.user_id
    //       }
    //     })
    //     .then(response => {
    //       this.$store.dispatch('loadTagCategories')
    //       // this.$store.dispatch('createTag',response.data)
    //       this.save_tag_category_form_display = false
    //       this.tag_category_name = ''
    //     })
    //     .catch(error => {
    //       // console.log(error)
    //     })
    // },
    deleteTag(t) {
      // console.log(t)
      // console.log(this.tagToDelete)
      let url = `${this.$globals.apiserver}/tags/${t}.json`
      // console.log(url)
      axios
        .delete(url, { tag: { id: t } })
        .then(response => {
          this.$store.dispatch('loadTags')
          this.dialog = false
          // this.$store.dispatch('deleteTag',t)
          // this.$router.push({path:`/artists/edit/${this.artist.id}`, params: {artist: this.artist}})
        })
        .catch(error => {
          // console.log(error)
        })
    },
    add_tag_to_current_selection(tag) {
      // console.log("add_tag_to_current_selection", tag)
      // var selected = Object.assign([],this.$store.state.currentSelection)
      // for (a in selected) {
      this.$store.dispatch('addTagToCurrentSelection', tag)
      // }
    },
    add_artworks_to_selection(artworks) {
      // var artworks = Object.assign([],this.$store.state.artworks)
      // var artworks_with_selected_tag = artworks.filter(function(artwork) {
      //   if (artwork.tags.length > 0) {
      //     // if (artwork.tags.length > 1) {
      //     //   // console.log(artwork.tags.length)
      //     // }
      //     return artwork.tags.some(a_tag => a_tag.id == tag)
      //   } else {
      //     return false
      //   }
      // })
      var selected = Object.assign([], this.$store.state.currentSelection)
      // console.log(artworks_with_selected_tag)
      // console.log(artworks)
      // console.log(selected)
      var out = selected

      for (let at of artworks) {
        // console.log(at.id)
        if (!selected.includes(at.id)) {
          out.push(at.id)
        }
        // if (selected.length > 0) {
        //   for (let a of selected) {
        //     if (at.id != a.id) {
        //       out.push(at.id)
        //     }
        //   }
        // } else {
        //   out = artworks.map(a => a.id)
        // }
      }

      // artworks_with_selected_tag = this.$store.state.artwork_tags.filter(function(at){ return artwork_id == tag})
      // new_selection =
      // console.log(selected)
      this.$store.dispatch('addToCurrentSelection', out)
    },
    show_artworks_with_tag() {
      this.$store.dispatch('setCurrentSelection', temp_selection)
      return null
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/* table.v-table thead td:not(:nth-child(1)), table.v-table tbody td:not(:nth-child(1)), table.v-table thead th:not(:nth-child(1)), table.v-table tbody th:not(:nth-child(1)), table.v-table thead td:first-child, table.v-table tbody td:first-child, table.v-table thead th:first-child, table.v-table tbody th:first-child { padding: 0px 5px !important} */
</style>



// WEBPACK FOOTER //
// src/components/tags/Tags.vue